import React, { Component } from "react";
import PropTypes from "prop-types";
import * as ReactSpark from "react-spark";

import { isLinkOnInquiryRootPage, extractPAndCCodes } from './helpers.js';

const { Masthead } = ReactSpark;

const continueLoanRoutes = ['ping-app#/my-profile/', 'ping-app#/my-dashboard/', 'app#/my-profile/', 'app#/my-dashboard/'];

function onToggle() {
  const element = document.getElementById("session-links-0");
  if (element.text.includes("Out")) {
    element.classList.toggle("sprk-u-Display--none");
  }
}

function forceHideSignOut() {
  const element = document.getElementById("session-links-0");
  if (element.text.includes("Out") && !element.classList.contains("sprk-u-Display--none")) {
    element.classList.add("sprk-u-Display--none");
  }
}

class AppMasthead extends Component {
  constructor(props) {
    super(props);
    const {
      mainAppRoot,
      rocketAccountLogoutUrl,
      rocketAccountGlobalPreferenceCenterUrl,
      pingAppUrl
    } = this.props;

    this.siteLinks = [
      {
        active: false,
        text: "Personal Loans",
        links: [
          {
            text: "Personal Loans",
            href: `${mainAppRoot}personal-loans`
          },
          {
            text: "Solar Loan",
            href: `${mainAppRoot}solar-loans`
          },
          {
            text: "Debt Consolidation Loan",
            href: `${mainAppRoot}debt-consolidation-personal-loans`
          },
          {
            text: "Home Improvement Loan",
            href: `${mainAppRoot}home-improvement-personal-loans`
          },
          {
            text: "Auto Loan",
            href: `${mainAppRoot}auto-personal-loans`
          },
          {
            text: "Other Personal Loan Uses",
            href: `${mainAppRoot}other-uses-for-a-personal-loan`
          }
        ]
      },
      {
        active: false,
        text: "Mortgages",
        links: [
          {
            text: "Refinance",
            href: "https://rocketmortgage.com/refinance/get-started?qls=RLR_0000001.000000007"
          },
          {
            text: "Buy A Home",
            href: "https://rocketmortgage.com/purchase/get-started?qls=RLR_0000001.000000005"
          },
        ]
      },
      {
        text: "Learning Center",
        href: `${mainAppRoot}learn`
      },
      {
        text: "Contact Us",
        href: `${mainAppRoot}contact-us`
      }
    ];

    this.loggedIn = {
        mainLinks: [
            {
                text: "(800) 333-7625",
                href: `tel:800-333-7625`
            },
            {
                icon: "user",
                links: [
                    {
                        text: "My Settings",
                        href: `${pingAppUrl}my-profile/`
                    },
                    {
                        text: "Dashboard",
                        href: `${pingAppUrl}my-dashboard/`
                    }, 
                    {
                      text: "Sign-In & Security",
                      href: `${rocketAccountGlobalPreferenceCenterUrl}`
                    }
                ],
                chevron: true
            },
            {
                onClick: this.signout,
                text: "Sign Out",
                buttonVariant: "secondary",
                href: rocketAccountLogoutUrl,
            }
        ],
        sessionLinks: [
            {
                onClick: this.signout,
                text: "Sign Out",
                variant: "plain",
                href: rocketAccountLogoutUrl,
            }
        ]
    };

    this.state = this.generateLinks(props);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.generateLinks(nextProps));
  }

  componentDidMount() {
    window.addEventListener('popstate', this.historyUpdate);
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.historyUpdate);
  }

  historyUpdate = () => {
    this.setState(this.generateLinks(this.props));
    forceHideSignOut();
  }

  signout = () => {
    const { performLogout } = this.props;
    performLogout();
  }

  generateLinks(props) {
    if (props.isLoggedIn) {
      if (props.preClose) {
        return {
          siteLinks: this.getContinueLoan(),
          mainLinks: this.loggedIn.mainLinks,
          narrowNavLinks: this.getLoggedInNarrowNavLinks(),
          sessionLinks: this.loggedIn.sessionLinks
        };
      }
      return {
        siteLinks: this.siteLinks,
        mainLinks: this.loggedIn.mainLinks,
        narrowNavLinks: this.getLoggedInNarrowNavLinks(),
        sessionLinks: this.loggedIn.sessionLinks
      };
    }
    const loggedOutLinks = this.getLoggedOut();
    return {
      siteLinks: this.siteLinks,
      mainLinks: loggedOutLinks.mainLinks,
      narrowNavLinks: loggedOutLinks.narrowNavLinks,
      sessionLinks: loggedOutLinks.sessionLinks
    };
  }

  getContinueLoan() {
    const { continueLoan, loanDenied } = this.props;
    if(!loanDenied) {
      for (let i = 0; i < continueLoanRoutes.length; i++) {
        if (window.location.href.indexOf(continueLoanRoutes[i]) > -1) {
          return [
            {
              text: "Continue Loan",
              onClick: continueLoan,
              buttonVariant: "primary"
            }
          ];
        }
      }
    }

    return [];
  }

  getLoggedOut() {
    const { rocketAccountSplitScreenLoginUrl, isLoggedIntoRocketAccount, rocketAccountLogoutUrl } = this.props;

    return {
      mainLinks: this.getMainLinks(),
      narrowNavLinks: this.siteLinks.concat(this.getMainLinks('secondary')),
      sessionLinks: isLoggedIntoRocketAccount ? [
        {
            id: "logout",
            text: "Sign Out",
            href: rocketAccountLogoutUrl,
            variant: "plain"
        }
      ] : [
          {
              id: "login",
              text: "Sign In",
              href: rocketAccountSplitScreenLoginUrl,
              variant: "plain"
          }
      ]
    };
  }

  getMainLinks(buttonVariant='primary') {
    const {
      appRoot,
      rocketAccountSplitScreenLoginUrl,
      isLoggedIntoRocketAccount,
      rocketAccountLogoutUrl
    } = this.props;

    // Links regenerated with history change and on page load,
    // using window.location here should be safe
    const fullCurrentUrlObj = window.location;
    const pAndCObj = extractPAndCCodes(fullCurrentUrlObj);
    const fullApplyLink = appRoot + (pAndCObj != null ? `?p=${pAndCObj.p}&c=${pAndCObj.c}` : '');

    const mainLinks = [];

    if (isLinkOnInquiryRootPage(window.location.href) === false) {
      mainLinks.push({
        text: "Apply Now",
        href: fullApplyLink,
        buttonVariant
      });
    }

    if (isLoggedIntoRocketAccount) {
      mainLinks.push({
        text: "Sign Out",
        buttonVariant: "secondary",
        href: rocketAccountLogoutUrl,
        className: "narrow-session-link"
      });
    } else {
      mainLinks.push({
        id: "login",
        text: "Sign In",
        href: rocketAccountSplitScreenLoginUrl,
        buttonVariant: "secondary",
        className: "narrow-session-link"
      });
    }

    return mainLinks;
  }

  getLoggedInNarrowNavLinks() {
    const {
      continueLoan,
      loanDenied,
      mainAppUrl,
      preClose,
      rocketAccountLogoutUrl,
      rocketAccountGlobalPreferenceCenterUrl
    } = this.props;

    const isContinueLoanRoute = continueLoanRoutes.some(route => window.location.href.includes(route))

    const showContinueLoanBtn = !loanDenied && preClose && isContinueLoanRoute;

    const narrowNavLinks = [
      // Conditionally displaying objects to arrays https://codeandsuch.github.io/conditional-array-object-literals/
      ...( showContinueLoanBtn ? [{
          text: "Continue Loan",
          buttonVariant: "secondary",
          onClick: () => {
            forceHideSignOut();
            continueLoan();
          }
      }] : []),
      {
          onClick: this.signout,
          text: "Sign Out",
          buttonVariant: "secondary",
          href: rocketAccountLogoutUrl,
          className: "narrow-session-link"
      },
      {
          text: "(800) 333-7625",
          href: `tel:800-333-7625`,
          onClick: forceHideSignOut
      },
      {
          text: "My Settings",
          href: `${mainAppUrl}my-profile/`,
          onClick: forceHideSignOut
      },
      {
          text: "Dashboard",
          href: `${mainAppUrl}my-dashboard/`,
          onClick: forceHideSignOut
      }, 
      {
        text: "Sign-In & Security",
        href: `${rocketAccountGlobalPreferenceCenterUrl}`,
        onClick: forceHideSignOut
      }
    ];

    return narrowNavLinks;
  }

  render() {
    const { logo, mainAppRoot } = this.props;

    return (
        <Masthead>
            <Masthead.Content>
                <Masthead.Hamburger
                    onToggle={onToggle}
                />
                <Masthead.Logo
                    href={mainAppRoot}
                    imgAlt="Rocket Loans Logo"
                    imgSrc={logo}
                    screenReaderText="Go to the home page"
                    imgWidth="200"
                />
                <Masthead.SessionLinks links={this.state.sessionLinks} />
                <Masthead.LittleNav
                    siteLinks={this.state.siteLinks}
                    links={this.state.mainLinks}
                />
            </Masthead.Content>
            <Masthead.NarrowNav links={this.state.narrowNavLinks} />
        </Masthead>
    );
  }
}


AppMasthead.propTypes = {
  logo: PropTypes.string.isRequired,
  appRoot: PropTypes.string.isRequired,
  mainAppUrl: PropTypes.string.isRequired,
  mainAppRoot: PropTypes.string.isRequired,
  pingAppUrl: PropTypes.string.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  isLoggedIntoRocketAccount: PropTypes.bool.isRequired,
  preClose: PropTypes.bool.isRequired,
  loanDenied: PropTypes.bool.isRequired,
  rocketAccountLogoutUrl: PropTypes.string.isRequired,
  rocketAccountSplitScreenLoginUrl: PropTypes.string.isRequired,
  rocketAccountGlobalPreferenceCenterUrl: PropTypes.string.isRequired,
  performLogout: PropTypes.func,
  continueLoan: PropTypes.func
};

AppMasthead.LoggedOut = () => (
  <AppMasthead
    isLoggedIn={false}
    preClose={false}
    loanDenied={false}
    appRoot="/inq/index.html#/"
    mainAppRoot=""
    mainAppUrl="/app#/"
    pingAppUrl="/ping-app#/"
    logo="images/L-RocketLoans-RGB-Horz.svg"
  />
);

export default AppMasthead;
